import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import { CONTACTS_DETAILS_LIST } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/actions-panel";

import ContactDetailsFilter from "../../components/filters/ContactDetailsFilter/ContactDetailsFilter";
import ContactDetailsFilterResult from "../../components/filters/ContactDetailsFilter/ContactDetailsFilterResult";
import { contactsFilterCategoryMap } from "../../types/contactsFilterCategory";

import FindContactDetailsFilter from "./ContactDetailsFilter";

const createContactDetailsFilter = (): SearchFilterInstance => {
    return {
        key: "contactDetails",
        trackingName: "Contact Details",
        apiCategory: "contactsFilters",
        title: { key: "si.lead_gen_filters.category.contact_details.name" },
        tooltipText: { key: "si.lead_gen_filters.category.contact_details.tooltip" },
        filter: new FindContactDetailsFilter({
            options: CONTACTS_DETAILS_LIST,
        }),
        filterView: ContactDetailsFilter,
        filterResultView: ContactDetailsFilterResult,
        category: contactsFilterCategoryMap.contacts,
    };
};

export default createContactDetailsFilter;
